import React from "react";
import { HeaderGeneral } from "../components/header-general";
import { Layout } from "../components/layout";
import SEO from "../components/seo";
import { MaxWidth, READ_WIDTH } from "../utils/style";
import RTF from "../components/rtf";
import { useStaticQuery, graphql } from "gatsby";

const Impressum = () => {
  const data = useStaticQuery(graphql`
    {
      contentfulHtml(uid: { eq: "impressum" }) {
        content {
          json
        }
      }
    }
  `);

  return (
    <Layout>
      <SEO title="Impressum" />
      <HeaderGeneral smallHeaderGeneral>
        <>
          <div className="circle-text">
            <h1>Impressum</h1>
          </div>
          <div
            className="circle"
            style={{
              backgroundImage: `url(${require("../images/impressum.jpg")})`
            }}
          />
        </>
      </HeaderGeneral>
      <MaxWidth greyGradient maxWidth={READ_WIDTH}>
        <RTF content={data.contentfulHtml.content.json} />
      </MaxWidth>
    </Layout>
  );
};

export default Impressum;
